export function isPerm (perms,perm_name) { 
      return perms.indexOf(perm_name) > -1
	  }


// WEBPACK FOOTER //
// ./src/utils/is_perm.js